
      var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgLightBlackIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M11.988 1c3.82 0 6.989 3.253 7.012 7.246 0 2.415-1.165 4.519-2.795 5.738v1.794c0 .502-.42.909-.91.956l-6.404.527h-.094a.943.943 0 0 1-.652-.263c-.187-.167-.35-.43-.35-.693V13.96C5.932 12.646 5 10.685 5 8.246 5 4.253 8.168 1 11.988 1Zm0 1.913c-2.818 0-5.125 2.392-5.101 5.333 0 1.96.745 3.395 2.352 4.352a.99.99 0 0 1 .42.837v1.841l4.658-.382v-1.46c0-.334.163-.669.466-.836 1.468-.813 2.307-2.44 2.33-4.352 0-2.941-2.306-5.333-5.125-5.333ZM15.226 19.796l-6.36.478h-.07c-.488 0-.884-.383-.93-.885a.954.954 0 0 1 .861-1.028l6.36-.478a.918.918 0 0 1 1.001.884.954.954 0 0 1-.862 1.029ZM13.2 22.809l-2.283.19h-.07c-.49 0-.885-.382-.932-.884a.954.954 0 0 1 .862-1.028l2.306-.191a.926.926 0 0 1 .979.884.953.953 0 0 1-.862 1.029Z",
  fill: "#000"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.692 8.222c-.046.43-.396.765-.815.765h-.07a.825.825 0 0 1-.722-.909c.14-1.363-1.025-1.865-1.165-1.913a.87.87 0 0 1-.489-1.076c.14-.43.606-.67 1.025-.502.862.31 2.446 1.483 2.236 3.635Z",
  fill: "#000"
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\">\r\n<path d=\"M11.9883 1C15.8086 1 18.9767 4.25262 19 8.24609C18.9999 10.6609 17.8354 12.7648 16.2051 13.9844V15.7783C16.205 16.2805 15.7851 16.6866 15.2959 16.7344L8.89062 17.2607H8.79688C8.56396 17.2607 8.30756 17.1654 8.14453 16.998C7.95826 16.8307 7.79506 16.5676 7.79492 16.3047V13.9609C5.93164 12.6458 5.00011 10.6849 5 8.24609C5 4.25264 8.16801 1.00004 11.9883 1ZM11.9883 2.91309C9.16965 2.91309 6.86342 5.30479 6.88672 8.24609C6.88684 10.2066 7.63218 11.6412 9.23926 12.5977C9.51874 12.7889 9.65913 13.0999 9.65918 13.4346V15.2764L14.3174 14.8936V13.4346C14.3174 13.0999 14.4805 12.765 14.7832 12.5977C16.2506 11.7847 17.0899 10.1589 17.1133 8.24609C17.1133 5.30483 14.8069 2.91316 11.9883 2.91309Z\" fill=\"black\"/>\r\n<path d=\"M15.2261 19.7958L8.86672 20.274H8.79684C8.30765 20.274 7.91164 19.8914 7.86506 19.3893C7.81847 18.8632 8.21447 18.4088 8.72695 18.361L15.0864 17.8827C15.6221 17.8349 16.0647 18.2414 16.088 18.7675C16.1346 19.2936 15.7386 19.7479 15.2261 19.7958Z\" fill=\"black\"/>\r\n<path d=\"M13.1996 22.8086L10.9168 22.9999H10.8469C10.3577 22.9999 9.96169 22.6173 9.9151 22.1152C9.86851 21.5891 10.2645 21.1347 10.777 21.0869L13.0832 20.8956C13.5956 20.8717 14.0382 21.2543 14.0615 21.7804C14.1081 22.3065 13.7121 22.7608 13.1996 22.8086Z\" fill=\"black\"/>\r\n<path d=\"M15.6923 8.22173C15.6457 8.65217 15.2963 8.98695 14.877 8.98695H14.8071C14.3645 8.93912 14.0384 8.5326 14.085 8.07825C14.2247 6.71521 13.06 6.21304 12.9202 6.16521C12.5009 5.99782 12.2913 5.51956 12.4311 5.08912C12.5708 4.65869 13.0367 4.41956 13.456 4.58695C14.3179 4.89782 15.9019 6.06956 15.6923 8.22173Z\" fill=\"black\"/>\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/light-black-icon.538fff218026dee738863dd6568ec875.svg"),
        {
          React: SvgLightBlackIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      